// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ASK_AN_EXPERT = "Poradne";
export const BADGE_REDACTION = "Redakcia";
export const CONTESTS = "S\u00fa\u0165a\u017ee";
export const HOMEPAGE_FEED_NAV_TAB_FORUM = "Diskusie";
export const HOMEPAGE_FEED_NAV_TAB_PHOTOBLOGS = "Blogy";
export const HOMEPAGE_NEW_ANNOUNCEMENT = "Ocitla si sa na novej \u00favodnej str\u00e1nke";
export const HOMEPAGE_NEW_CONTACT_FORM = "M\u00e1\u0161 k novej \u00favodnej str\u00e1nke pripomienky alebo n\u00e1vrhy?";
export const HOMEPAGE_NEW_CONTACT_FORM_LINK = "Nap\u00ed\u0161 n\u00e1m pros\u00edm!";
export const HOMEPAGE_NEW_CONTACT_FORM_LINK_URL = "https://www.modrykonik.sk/faq/form/";
export const HOMEPAGE_OLD_SWITCH = "Prepn\u00fa\u0165 na star\u00fa";
export const HOME_SHOW_MORE_POSTS = "Zobraz \u010fal\u0161ie";
export const MAIN_MENU_REVIEWS = "Recenzie";
